import { render, staticRenderFns } from "./BPMNMailTask.vue?vue&type=template&id=261fe5aa&"
import script from "./BPMNMailTask.vue?vue&type=script&lang=js&"
export * from "./BPMNMailTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports